import React from "react"
import { ReactComponent as AlertIcon } from "../../assets/svg/AlertIcon.svg";
import { ReactComponent as RightBlackArrow } from "../../assets/svg/RightBlackArrow.svg";

const ValuationErrorBox = () => {
  const BASE_URL = `${window.location.origin}`

  return (
    
  <div className="valuationErrorBox-container">
    <AlertIcon style={{
      marginRight: "8px",
      minWidth: "24px",
      minHeight: "24px"
    }}/>
    <div>
      <p className="valuationErrorBox-heading">An error in our process meant a valuation was given but we couldn’t register the request.</p>
      <p className="valuationErrorBox-paragraph">
        If you’d like to proceed with a sale, please contact a dealership near you so one of our experts can guide you through the next steps.
      </p>
      <div className="valuationErrorBox-linkContainer">
        <a 
          className="valuationErrorBox-link"
          href={`${BASE_URL}/contact-us`} 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Find a dealership 
          <RightBlackArrow />
        </a>
      </div>
    </div>
  </div>	
  );
};

export default ValuationErrorBox;